import React from "react";
import { CommentPropsItem } from "../comments/types";
import { useStyles } from "./style";

export const CommentCard = (props: CommentPropsItem) => {
    const classes = useStyles();

    return (
        <div className={classes.commentCardContainer}>
            <div className={classes.commentCardAuthorInfo}>
                <div>{props.name}</div>
                <div>{props.post}</div>
            </div>
            <div className={classes.commentText}>
                {props.body}
            </div>
        </div>
    );
};
